import { render, staticRenderFns } from "./WalletTabBar.vue?vue&type=template&id=8dd4d2ca&scoped=true&lang=pug"
import script from "./WalletTabBar.vue?vue&type=script&lang=js"
export * from "./WalletTabBar.vue?vue&type=script&lang=js"
import style0 from "./WalletTabBar.vue?vue&type=style&index=0&id=8dd4d2ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4d2ca",
  null
  
)

export default component.exports